import { adminApi } from "./adminApi";

const CHUNK = 4 * 1024 * 1024;

export async function uploadGalleryPhoto(galleryId, file, onProgress) {
  const { data: init } = await adminApi.post(`/galleries/${galleryId}/uploads/init`, {
    filename: file.name,
    content_type: file.type,
    size: file.size,
  });
  let sent = 0;
  while (sent < file.size) {
    const slice = file.slice(sent, sent + CHUNK);
    await adminApi.put(`/galleries/${galleryId}/uploads/${init.upload_id}/chunk`, slice, {
      headers: { "Content-Type": "application/octet-stream" },
    });
    sent += slice.size;
    onProgress?.(sent / file.size);
  }
  const { data } = await adminApi.post(`/galleries/${galleryId}/uploads/${init.upload_id}/complete`);
  return data;
}
